<template>
  <v-list
    nav
    dense
    class="tasklist-drawer"
  >
    <!-- 我的工作 -->
    <v-list-group
      no-action
      class="v-list-group--no-action-sm"
      :value="jobType === taskListJobType.MY_JOB"
      @click="expendChild('personalSubList')"
    >
      <template v-slot:activator>
        <v-list-item-content>
          <v-list-item-title>
            {{ $t('TaskList.MyJob') }}
            <span
              class="ml-3"
              :class="personalTotalJobNum > 0 ? 'pink--text': 'grey--text'"
            >{{ personalTotalJobNum }}</span>
          </v-list-item-title>
        </v-list-item-content>
      </template>

      <s-sub-list-groups
        ref="personalSubList"
        :items="items"
        :sub-item-job-nums="personalTotalSubItemJobNums"
        :job-type="taskListJobType.MY_JOB"
        :current-job-type="jobType"
        :current-path="currentPath"
      />
    </v-list-group>

    <!-- 群組工作 -->
    <v-list-group
      no-action
      class="v-list-group--no-action-sm"
      :value="jobType === taskListJobType.GROUP_JOB"
      @click="expendChild('groupSubList')"
    >
      <template v-slot:activator>
        <v-list-item-title>
          {{ $t('TaskList.GroupJob') }}
          <span
            class="ml-3"
            :class="groupTotalJobNum > 0 ? 'pink--text': 'grey--text'"
          >{{ groupTotalJobNum }}</span>
        </v-list-item-title>
      </template>

      <s-sub-list-groups
        ref="groupSubList"
        :items="groupItems"
        :sub-item-job-nums="groupTotalSubItemJobNums"
        :job-type="taskListJobType.GROUP_JOB"
        :current-job-type="jobType"
        :current-path="currentPath"
      />
    </v-list-group>

    <!-- 關注的工作 -->
    <v-list-group
      v-if="myAttentionStaffs.length > 0"
      no-action
      class="v-list-group--no-action-sm"
      :value="jobType === taskListJobType.ATTENTION_JOB"
      @click="expendChild('attentionSubList')"
    >
      <template v-slot:activator>
        <v-list-item-title>
          {{ $t('TaskList.AttentionJob') }}
          <span
            class="ml-3"
            :class="attentionTotalJobNum > 0 ? 'pink--text': 'grey--text'"
          >
            {{ attentionTotalJobNum }}
          </span>
        </v-list-item-title>
      </template>

      <s-sub-list-groups
        ref="attentionSubList"
        :items="attentionItems"
        :sub-item-job-nums="attentionTotalSubItemJobNums"
        :job-type="taskListJobType.ATTENTION_JOB"
        :current-job-type="jobType"
        :current-path="currentPath"
      />
    </v-list-group>

    <br>

    <v-btn
      block
      text
      large
      color="primary"
      class="btn--wrap"
      to="/tasklist/attentionTaskManage"
    >
      <template v-if="staffsAttentionMe.length > 0">
        {{ $chPtObjData('chinFollowedByStaffName', staffsAttentionMe[0]) }}
        <template v-if="staffsAttentionMe.length > 1">
          {{ $t('TaskList.AttentionManagement.AnotherPeople', [staffsAttentionMe.length - 1]) }}
        </template>
        {{ $t('TaskList.AttentionManagement.AttentionMyJob') }}
      </template>

      <template v-else>
        {{ $t('TaskList.AttentionManagement.Title') }}
      </template>
    </v-btn>

    <v-btn
      block
      text
      large
      color="primary"
      to="/tasklist/setting"
    >
      <v-icon
        small
        class="mr-1"
      >
        {{ mdiCogOutline }}
      </v-icon>
      {{ $t('Text.Setting') }}
    </v-btn>
  </v-list>
</template>

<style scoped>
  .v-chip .v-avatar {
    background: rgba(0,0,0,.23);
  }
</style>

<script>
import { mapState, mapGetters } from 'vuex'
import { workflow } from '../../../store/modules/workflow/workflow'
import workflowApi from '../../../api/workflow/workflow'
import store from '../../../store'
import { workflowModule, staffModule } from '../../../store/moduleName'
import { TASK_LIST_JOB_TYPE } from '@/constant/constant'
import { mdiCogOutline } from '@mdi/js'

import SSubListGroups from './STaskDrawer/SSubListGroups.vue'

// import { BUSINESS_CODE } from '../../../constant/constant'
// We're dynamically registering the
// `workflow` store module. This has
// the benefit of only loading this
// module, if it's actually needed.
// Before registering the module, we're
// checking if it's already registered
// which can happen in combination with
// webpacks hot reloading.
if (!store.state[workflowModule]) store.registerModule(workflowModule, workflow)

export default {
  components: {
    SSubListGroups
  },
  props: {
    title: {
      type: String,
      required: true
    }
  },
  data: () => ({
    mdiCogOutline: mdiCogOutline,
    currentPath: null,
    jobType: TASK_LIST_JOB_TYPE.MY_JOB,
    myAttentionStaffs: [],
    openedGroup: null
  }),
  computed: {
    ...mapState(
      {
        myInfo: state => state[staffModule].info
      }
    ),
    ...mapState(workflowModule, {
      originItems: state => state.items,
      // attentionItems: state => state.attentionItems,
      staffsAttentionMe: state => state.staffsAttentionMe
    }),
    ...mapGetters({
      personalTotalJobNum: workflowModule + '/countPersonalTotalJobNumber',
      groupTotalJobNum: workflowModule + '/countGroupTotalJobNumber',
      attentionTotalJobNum: workflowModule + '/countAttentionTotalJobNumber',
      personalTotalSubItemJobNums: workflowModule + '/countPersonalTotalSubItemJobNumbers',
      groupTotalSubItemJobNums: workflowModule + '/countGroupTotalSubItemJobNumbers',
      attentionTotalSubItemJobNums: workflowModule + '/countAttentionTotalSubItemJobNumbers'
    }),
    items () {
      return this.originItems
    },
    taskListJobType () {
      return TASK_LIST_JOB_TYPE
    },
    groupItems () {
      let result = []

      for (let item of this.items) {
        // console.log(item)
        let tempSubItems = item.subItems.filter(subItem => !!subItem.groupUrl)
        if (tempSubItems.length) {
          let tempItem = { ...item }
          tempItem.subItems = tempSubItems
          result.push(tempItem)
        }
      }
      return result

      // return this.items.filter(item => item.subItems.every(subItem => !!subItem.groupUrl))
    },
    attentionItems () {
      let result = []

      for (let item of this.items) {
        let tempSubItems = item.subItems.filter(subItem => !!subItem.attentionUrl)
        if (tempSubItems.length) {
          let tempItem = { ...item }
          tempItem.subItems = tempSubItems
          result.push(tempItem)
        }
      }
      return result
    }
  },
  watch: {
    $route: {
      handler: function () {
        this.currentPath = this.$router.currentRoute.path

        this.items.forEach(item => {
          item.subItems.forEach(subItem => {
            if ((this.currentPath.includes(subItem.url)) || (this.currentPath.includes(subItem.historyUrl))) {
              this.jobType = TASK_LIST_JOB_TYPE.MY_JOB
            } else if ((this.currentPath.includes(subItem.groupUrl)) || (this.currentPath.includes(subItem.groupHistoryUrl))) {
              this.jobType = TASK_LIST_JOB_TYPE.GROUP_JOB
            } else if (this.currentPath.includes(subItem.attentionUrl) || (this.currentPath.includes(subItem.attentionHistoryUrl))) {
              this.jobType = TASK_LIST_JOB_TYPE.ATTENTION_JOB
            }
          })
        })
      },
      immediate: true
    }
  },
  async created () {
    // this.$g2eOauth.getTokenBody().then(data => {
    //   this.$store.dispatch('workflow/countTraining', data.staff_code)
    // })
    await this.$store.dispatch(staffModule + '/getStaff')
    this.refreshCountAndAttention()
  },
  methods: {
    async refreshCountAndAttention () {
      this.getMyAttentionStaffs()
      await this.$store.dispatch(workflowModule + '/countBwItems')
      this.$store.dispatch(workflowModule + '/countPersonalItems')
      this.$store.dispatch(workflowModule + '/countGroupItems')
      this.$store.dispatch(workflowModule + '/countAttentionItems')
      this.$store.dispatch(workflowModule + '/getStaffsAttentionMe', this.myInfo.euid)
    },
    getMyAttentionStaffs () { // not include tasks count
      workflowApi.getFollowingStaffs(cb => {
        this.myAttentionStaffs = cb
      })
    },
    expendChild (subListName) {
      setTimeout(() => {
        // console.log(this.$refs)

        // this.$refs.personalSubList.collapse()
        // this.$refs.groupSubList.collapse()
        // this.$refs.attentionSubList.collapse()
        this.$refs[subListName].expendTheBest()
      }, 300)
    }
  }
}
</script>
